import AdminAddPasein from "../../components/AdminTreatmentCategory/TreatmentAdd";

export default function AddPasien() {
  return (
    <div style={{backgroundColor:"white"}}>
      <AdminAddPasein/>
    </div>
  );
}
